var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "div" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c("el-tab-pane", {
            attrs: { label: "设备拆分", name: "SplitTheData" },
          }),
          _c("el-tab-pane", {
            attrs: { label: "资产设备", name: "propertyInit" },
          }),
          _c("el-tab-pane", {
            attrs: { label: "备品备件", name: "fittingsInit" },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm.activeName === "SplitTheData"
            ? _c("SplitTheData", { ref: "SplitTheData" })
            : _vm._e(),
          _vm.activeName === "fittingsInit"
            ? _c("fittingsInit", { ref: "fittingsInit" })
            : _vm._e(),
          _vm.activeName === "propertyInit"
            ? _c("propertyInit", { ref: "propertyInit" })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }